export default function ProfileItem({ icon, label, value }) {
  return (
    <div className="flex gap-3 lg:gap-4">
      <div className="mt-1 text-[#8C8C8C] text-[18px] leading-none lg:text-[20px]">
        {icon}
      </div>

      <div className="min-w-0 flex flex-col gap-1">
        <span className="text-[13px] text-[#8C8C8C] lg:text-[14px]">
          {label}
        </span>

        <span className="text-[15px] font-medium text-[#0B1B3A] lg:text-[16px] truncate">
          {value}
        </span>
      </div>
    </div>
  );
}